(() => {
  if (window.PgCartTermsInitialized) return;
  window.PgCartTermsInitialized = true;

  const checkoutSelector = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href^="/checkout"]',
    'a[href*="/checkout"]',
    '.additional-checkout-buttons button',
    '.shopify-payment-button__button',
    '[data-shopify="payment-button"] button'
  ].join(',');

  const getScope = (element) => {
    return element?.closest('cart-drawer, #main-cart-footer, .cart__footer, body') || document;
  };

  const getTermsBox = (element) => {
    const scope = getScope(element);
    return scope.querySelector('[data-pg-cart-terms]') || document.querySelector('[data-pg-cart-terms]');
  };

  const getCheckbox = (termsBox) => termsBox?.querySelector('[data-pg-cart-terms-checkbox]');
  const getError = (termsBox) => termsBox?.querySelector('[data-pg-cart-terms-error]');

  const showWarning = (termsBox) => {
    if (!termsBox) return;

    const checkbox = getCheckbox(termsBox);
    const error = getError(termsBox);

    termsBox.classList.add('is-error');
    if (error) error.hidden = false;

    checkbox?.setAttribute('aria-invalid', 'true');
    termsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    checkbox?.focus({ preventScroll: true });
  };

  const isAccepted = (termsBox) => {
    return Boolean(getCheckbox(termsBox)?.checked);
  };

  const clearError = (termsBox) => {
    if (!termsBox) return;

    const error = getError(termsBox);
    const checkbox = getCheckbox(termsBox);

    termsBox.classList.remove('is-error');
    if (error) error.hidden = true;
    checkbox?.removeAttribute('aria-invalid');
  };

  const blockIfNeeded = (event, trigger) => {
    const termsBox = getTermsBox(trigger);
    if (!termsBox || isAccepted(termsBox)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    showWarning(termsBox);
    return true;
  };

  document.addEventListener(
    'click',
    (event) => {
      const checkoutTrigger = event.target.closest(checkoutSelector);
      if (!checkoutTrigger) return;

      blockIfNeeded(event, checkoutTrigger);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter || document.activeElement;
      const isCheckoutSubmit =
        submitter?.getAttribute?.('name') === 'checkout' ||
        submitter?.matches?.(checkoutSelector) ||
        event.target?.getAttribute?.('action')?.includes('/checkout');

      if (!isCheckoutSubmit) return;

      blockIfNeeded(event, submitter || event.target);
    },
    true
  );

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-pg-cart-terms-checkbox]');
    if (!checkbox) return;

    if (checkbox.checked) {
      clearError(checkbox.closest('[data-pg-cart-terms]'));
    }
  });
})();
